import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"

const getData = graphql`
  {
    cat: allContentfulCategorie(filter: { node_locale: { eq: "fr" } }) {
      nodes {
        title
        slug
        node_locale
      }
    }
  }
`
const CatFr = () => {
  const data = useStaticQuery(getData)
  const home = "/"
  return (
    <ul>
      <li>
        <Link to="/fr/commercants">-Tout-</Link>
      </li>
      {data.cat.nodes.map((item, index) => {
        return (
          <li key={index}>
            <Link
              to={`/${item.node_locale}/commercants/${item.slug}`}
              activeClassName="is-active"
              partiallyActive={item.path === home ? false : true}
            >
              {item.title}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default CatFr
